import { create } from 'zustand';

interface SurveyState {
    currentStep: number;
    answers: { [stepId: string]: string }; // Use single string per step
    setCurrentStep: (step: number) => void;
    setAnswer: (stepId: string, answer: string) => void;
    resetAnswers: () => void;
    registrationStep: number;
    setRegistrationStep: (step: number) => void;
}

export const useSurveyStore = create<SurveyState>((set) => ({
    currentStep: 0,
    answers: {},
    currentStepTitle: '',
    registrationStep: 1,
    setCurrentStep: (step) => set(() => ({ currentStep: step })),
    setRegistrationStep: (step) => set(() => ({ registrationStep: step })),
    setAnswer: (stepId, answer) =>
        set((state) => ({
            answers: {
                ...state.answers,
                [stepId]: answer, // Overwrite the previous answer
            },
        })),
    resetAnswers: () => set(() => ({ answers: {} })),
}));
